import React from 'react';
import { Helmet } from 'react-helmet';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../style/main.scss';
import SideBarButton from '../components/SideBarButton/SideBarButton';
import TopHeader from '../components/TopHeader/TopHeader';
import ProjectInfo from '../components/ProjectInfo';
import Pdf from '../files/TSBK03_projektrapport.pdf';

const repoP = 'https://github.com/iriskotsinas/TNM084-L-System-Project';

const item = {
  title: 'Procedural Generation with Lindenmayer Systems',
  description:
    'The course TNM084 Procedural Images, taken in fall 2021, consisted of four labs and an individual project. The course covered topics within computer graphics such as procedural generation.',
  description2:
    'This project explores how a tree can be created with the use of a Lindenmayer system (L-system) and instancing. It also investigates how noise can be applied to a plane to simulate snow as well as the simulation of falling snowflakes. For the terrain, Fractal Brownian Noise has been used. Instancing and billboards were used to simulate the snowflakes. For the tree, an L-system was created and used, as well as instancing for the branches and leaves to increase the performance. The result of this project is a web application built with TypeScript and WebGL that runs in real-time. The project resulted in a semi-realistic simulation of a tree in a snowy environment.',
  image: 'tree2.png',
  image2: 'tree3.png',
  slug: '/modelling-animation',
  report: '',
  sourcecode: repoP,
  simulation: 'https://iriskotsinas.github.io/TNM084-L-System-Project/',
  figureText: '',
};

export default function LSystem() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Iris Kotsinas</title>
        <html lang="en" />
        <meta name="description" content="Iris Portfolio" />
      </Helmet>
      <TopHeader isStartPage={false} />
      <ProjectInfo item={item} isSpecial={false} />
      <SideBarButton showBelow={70} />
    </>
  );
}
